<div class="sidebar-wrapper" data-simplebar="true" (mouseover)="over(1)" (mouseout)="over(2)">
    <div class="sidebar-header">
        <div>
            <!-- <img src="assets/images/logo-icon.png" class="logo-icon" alt="logo icon"> -->
        </div>
        <div>
            <h4 class="logo-text"> HVF </h4>
        </div>
        <div class="toggle-icon ms-auto"  (click) = "service.sideIcon()"><i class='bx bx-arrow-to-left'></i>
        </div>
    </div>
    <!--navigation-->
    <ul class="metismenu" id="menu">
        <li>
            <a href='javascript:void(0)' routerLink='/dashboard'>
                <div class="parent-icon"><i class='bx bx-home-circle'></i>
                </div>
                <div class="menu-title">Dashboard</div>
            </a>
        </li>

        <li>
            <a routerLink="/user-listing">
                <div class="parent-icon"><i class="bx bx-group"></i>
                </div>
                <div class="menu-title">Manage Users</div>
            </a>
        </li>
        <li> 
            <a href='javascript:void(0)' routerLink='/interest'> 
                <div class="parent-icon"><i class="bx bx-money"></i></div>
                <div class="menu-title"> Manage Interest</div>
            </a>
        </li>
        <li> 
            <a href='javascript:void(0)' routerLink='/hair-type'> 
                <div class="parent-icon"><i class="bx bx-health"></i></div> 
                <div class="menu-title">Manage Hair Type </div>
            </a>
        </li>
        <li> 
            <a href='javascript:void(0)' routerLink='/eye-type'> 
                <div class="parent-icon"><i class="bx bx-show"></i> </div>
                <div class="menu-title">Manage Eye Type </div>
            </a>
        </li>
            <li> 
                <a href='javascript:void(0)' routerLink='/langugae'>
                    <div class="parent-icon"><i class="bx bx-book-reader"></i> </div> 
                    <div class="menu-title">Manage Language</div></a>
            </li>
            <!-- <li> <a href='javascript:void(0)' routerLink='/category'> <div class="parent-icon"><i class="bx bx-group"></i>
                </div><div class="menu-title"> Manage Category</div></a>
            </li> -->
            <!-- <li> 
                <a href='javascript:void(0)' routerLink='/withdraw-transaction'> 
                    <div class="parent-icon"><i class="bx bx-user-pin"></i> </div> 
                    <div class="menu-title">Manage Prefrence</div>
                </a>
            </li> -->
            <li> 
                <a href='javascript:void(0)' routerLink='/body-type'> 
                    <div class="parent-icon"><i class="bx bx-body"></i></div>
                    <div class="menu-title">Manage Body Type</div>
                </a>
            </li>
            <li> 
                <a href='javascript:void(0)' routerLink='/withdraw-transaction'> 
                    <div class="parent-icon"><i class="bx bx-globe"></i> </div> 
                    <div class="menu-title">Manage Withdraw Transaction</div></a>
            </li>
            
        <li>
            <a routerLink="/transaction">
                <div class="parent-icon"><i class="bx bx-money"></i>
                </div>
                <div class="menu-title">Manage Transaction</div>
            </a>
        </li>
       
        <li>
            <a routerLink="/app-version">
                <div class="parent-icon">
                    <i class='bx bx-message-square-edit'></i>
                </div>
                <div class="menu-title">Manage App Version</div>
            </a>
        </li>
   
        
        <!-- <li>
            <a routerLink="/report-post">
                <div class="parent-icon">
                    <i class='bx bx-repeat'></i>
                </div>
                <div class="menu-title">Report Post</div>
            </a>
        </li> -->
        <li>
            <a routerLink="/report-user">
                <div class="parent-icon">
                    <i class='bx bx-repeat'></i>
                </div>
                <div class="menu-title">Report User</div>
            </a>
        </li>
        <!-- <li>
            <a routerLink="/report-comment">
                <div class="parent-icon">
                    <i class='bx bx-repeat'></i>
                </div>
                <div class="menu-title">Report Comment</div>
            </a>
        </li> -->
        <!-- <li>
            <a routerLink="/request">
                <div class="parent-icon">
                    <i class='bx bx-message-square-edit'></i>
                </div>
                <div class="menu-title">App Request</div>
            </a>
        </li> -->
        <!-- <li>
            <a routerLink="/faq">
                <div class="parent-icon">
                    <i class='bx bx-message-square-edit'></i>
                </div>
                <div class="menu-title">FAQ</div>
            </a>
        </li> -->
        <li>
            <a routerLink="/static-page">
                <div class="parent-icon"><i class="bx bx-book-content"></i>
                </div>
                <div class="menu-title">Content Management System</div>
            </a>
        </li>
        <!-- <li>
            <a href="table.html">
                <div class="parent-icon">
                    <i class='bx bx-grid-alt'></i>
                </div>
                <div class="menu-title">Table</div>
            </a>
        </li>
        <li>
            <a href="accordions.html">
                <div class="parent-icon">
                    <i class='bx bx-repeat'></i>
                </div>
                <div class="menu-title">Accordions</div>
            </a>
        </li>
        <li>
            <a href="forms.html">
                <div class="parent-icon">
                    <i class='bx bx-message-square-edit'></i>
                </div>
                <div class="menu-title">Form</div>
            </a>
        </li>
         -->
        <!-- <li class="menu-label">Table Pages</li> -->
    </ul>
    <!--end navigation-->
</div>